import { SellersApiRemoteService } from '../../Services/api/sellers/sellers-service'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'

export class DestroySellersUseCase implements IFormUsecase<string, void> {
  constructor(private readonly SellersApi: SellersApiRemoteService) {}

  public async handle(sellerId: string): Promise<Result<void>> {
    try {
      const response = await this.SellersApi.destroy(sellerId)

      if (response.isFailure) {
        return response
      }

      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }
}
